import type { IconProps } from './types';
import './icons.css';

export default function Notification({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-notification ${className || ''}`}
      fill="none"
    >
      <path
        d="M14.646 20c-.705.622-1.632 1-2.646 1a3.985 3.985 0 0 1-2.646-1m8.643-6.82V10c0-3.322-2.675-6-5.997-6s-6.034 2.564-6.034 6v3.16c0 .482-.075.962-.223 1.42l-.738 2.292c-.02.063.025.128.089.128h13.77a.1.1 0 0 0 .094-.13l-.743-2.307a4.505 4.505 0 0 1-.218-1.382Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
